<template>
    <div class="show_posters" :style="{ left: left }">
        <div
            style="
                flex: 1;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
            "
        >
            <div class="save_loading" v-show="show_loading">
                <img src="@/assets/images/loading.gif" alt />
                <div
                    v-if="!is_load_fail"
                    style="color: #fff; justify-content: center"
                    class="save_wrong"
                >
                    正在拼命加载中，请您稍后...
                </div>
                <div style="color: #fff" class="save_wrong" v-else>
                    <img src="@/assets/images/poster-close.png" class="poster-close" alt />
                    <div style="color: #fff" class="save_wrong">
                        <img src="@/assets/images/poster-close.png" class="poster-close" alt />
                        网络出小差了，
                        <span class="retry_text" @click="imgs_reload">请点击重试</span>
                        <img class="retry_img" src="@/assets/images/refresh.png" alt />
                    </div>
                </div>
            </div>
            <div class="poster_box" v-show="!show_loading && url">
                <img class="posters_img" />
                <div class="save_posters" v-show="!show_loading && !isInApp">
                    <img
                        src="@/assets/images/poster-close.png"
                        class="poster-close"
                        alt
                        @click="$emit('close')"
                    />
                    <span class="tip">
                        {{ isPC ? '微信扫一扫分享好友' : '长按海报保存到相册，分享好友' }}
                    </span>
                </div>
            </div>
        </div>
        <share-footer
            @shareWx="shareWx"
            @sharePyq="sharePyq"
            :isShow="isShareFooter"
            :isUrl="url"
            @cancle="$emit('close')"
            @shareCard="shareCard"
            @shareLink="$emit('close')"
        ></share-footer>
        <div id="fixed_wrap">
            <div class="poster-content-header">
                <div class="share-cover">
                    <img src="@/assets/images/jaizi.png" class="share-jiazi" alt />
                    <!-- 大会的图片 -->
                    <div class="cover">
                        <img :src="shareData.cover" class="poster-share-cover" alt />
                    </div>
                </div>
            </div>
            <div class="share-title" style="background-color: #fff">
                <!-- 大会标题 -->
                <span class="share-meeting" v-html="replaceLine(shareData.title)"></span>
                <!-- 大会的状态和时间 -->
                <div class="share-date">
                    <div class="share-title-tip" v-if="shareData.type == 1">直播</div>
                    <div class="share-title-tip" v-if="shareData.type == 2">交互</div>
                    <div class="share-title-tip" v-if="shareData.type == 3">直播+交互</div>
                    <div class="share-title-tip" v-if="shareData.type == 4">直播间</div>
                    <div class="share-title-tip" v-if="shareData.type == 5">直播间+直播</div>
                    <div v-if="shareData.is_big_meeting == 1" class="share-time">
                        <!-- {{ shareData.begin_time.replace(/-/g, '/') }}-{{
                                shareData.end_time.replace(/-/g, '/')
            }}-->
                        {{ shareData.begin_time }}-{{ shareData.end_time }}
                    </div>
                    <div v-else class="share-time">
                        <!-- {{ shareData.begin_time.replace(/-/g, '/') }}-{{
                                shareData.end_time.replace(/-/g, '/')
            }}-->
                        {{ shareData.begin_time }}-{{ shareData.end_time }}
                    </div>
                </div>
            </div>

            <div class="share-footer" v-if="shareData.meeting_id == '59023'">
                <!-- <img :src="shareData.us> -->
                <div class="footer-left">
                    <img
                        src="@/assets/images/share_logo.png"
                        style="width: 3.5rem; height: 3.5rem"
                        alt
                    />
                </div>
                <div class="center-text">
                    <div class="dan-right-text" style="align-items: flex-start; width: 100%">
                        <p>关注左侧检验科空间微信公众号</p>
                        <p>获取更多会议信息</p>
                        <!-- <p>扫描右侧二维码</p>
            <p>观看精彩直播</p>-->
                    </div>
                    <div class="dan-right-text" style="align-items: flex-end; width: 100%">
                        <!-- <p>关注检验科空间微信公众号</p>
            <p>获取更多会议信息</p>-->
                        <p>扫描右侧二维码</p>
                        <p>观看精彩直播</p>
                    </div>
                </div>
                <div class="footer-right">
                    <!-- 二维码 -->
                    <div class="right-erweima">
                        <img :src="shareData.meeting_share_qrcode" alt />
                    </div>
                </div>
            </div>
            <div class="share-footer" v-else>
                <!-- <img :src="shareData.us> -->
                <div class="footer-left">
                    <img src="@/assets/images/yipu_logo.png" alt />
                    <span>医谱</span>
                </div>
                <div class="footer-right">
                    <div class="right-text">
                        <span>保存本图片</span>
                        <span>用微信识别或手机扫描二维码</span>
                        <span>观看精彩内容</span>
                    </div>
                    <!-- 二维码 -->
                    <div class="right-erweima">
                        <img :src="shareData.meeting_share_qrcode" alt />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import os from '@utils/os'
import ImgLoadListener from '@utils/imageLoadListener'
import shareFooter from '../ShareFooter/index.vue'
import { NativeMessageShare } from '@utils/nativeBridge/nativeMessage'
export default {
    components: { shareFooter },
    props: {
        shareData: {
            type: Object,
            default: {}
        },
        left: {
            type: String
        }
    },
    data() {
        return {
            time: '',
            url: '',
            imgListener: null,
            show_loading: false,
            is_load_fail: false,
            isShareFooter: true
        }
    },
    computed: {
        isPC() {
            return os.isPC()
        },
        isInApp() {
            return navigator.userAgent.indexOf('YPAPP') !== -1
        }
    },

    mounted() {},
    methods: {
        shareWx() {
            if (!this.url) {
                this.$nativeBridge.sendMessage(
                    new NativeMessageShare(
                        {
                            link: window.location.href,
                            title: this.shareData.title,
                            img: this.shareData.cover
                            // desc: `${this.shareData.begin_time}-${this.shareData.end_time}`
                        },
                        'appMessage'
                    )
                )
            } else {
                this.$nativeBridge.sendMessage(new NativeMessageShare(this.url))
            }
            this.$emit('close')
        },
        sharePyq() {
            if (!this.url) {
                this.$nativeBridge.sendMessage(
                    new NativeMessageShare(
                        {
                            link: window.location.href,
                            title: this.shareData.title,
                            img: this.shareData.cover
                            // desc: `${this.shareData.begin_time}-${this.shareData.end_time}`
                        },
                        'timeline'
                    )
                )
            } else {
                this.$nativeBridge.sendMessage(new NativeMessageShare(this.url, 'timeline'))
            }
            this.$emit('close')
        },
        shareCard() {
            window.scrollTo(0, 0)
            this.show_loading = true
            this.add_listener()
            if (!this.isInApp) {
                this.isShareFooter = false
            }
        },
        replaceLine(str) {
            if (!str) return ''
            str = str.replace(/\r\n/g, '<br/>')
            str = str.replace(/\n/g, '<br/>')
            str = str.replace(/\s/g, '&nbsp')
            return str
        },
        screenshots() {
            let self = this
            import('@utils/html2canvas.js').then(res => {
                console.log(res)
                res.default(document.querySelector('#fixed_wrap'), {
                    useCORS: true,
                    allowTaint: false,
                    dpi: window.devicePixelRatio * 1,
                    scale: window.devicePixelRatio * 1
                })
                    .then(canvas => {
                        self.$nextTick(function () {
                            const url = canvas.toDataURL('image/png')
                            document.querySelector('.posters_img').src = url
                            this.url = url

                            self.show_loading = false
                        })
                    })
                    .catch(e => {
                        console.error('error--> ', e)
                    })
            })
        },
        add_listener() {
            this.show_loading = true
            let self = this
            this.imgListener = new ImgLoadListener({
                node: '#fixed_wrap',
                done: function () {
                    self.$nextTick(() => {
                        self.screenshots()
                        self.is_load_fail = false
                    })
                },
                fail: function () {
                    self.is_load_fail = true
                }
            })
        },
        imgs_reload() {
            this.imgListener.reload()
        }
    }
}
</script>

<style scoped lang="scss">
.center-text {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    height: 3.5rem;
    padding: 0 0.3rem;
}
#fixed_wrap {
    width: 100%;
    position: absolute;
    left: -100000px;
    top: 0;
    z-index: -111;
    background: #fff;
    padding: 0 0.2rem;
}
.cover {
    padding-bottom: 56%;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-top: -0.47rem;
}

.show_posters {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    // padding: 1rem 0.5rem;
    box-sizing: border-box;
}
.poster-share-cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: 0.3rem 0.5rem 0.2rem rgba(206, 206, 206, 0.5);
}
.share-jiazi {
    position: relative;
    z-index: 2;
    width: 100%;
}
.share-cover {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
}
.share-title {
    padding: 0.5rem 0.4rem;
    box-sizing: border-box;
}
.share-title span {
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
}
.share-date {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
}
.share-date,
.share-time {
    display: flex;
    align-items: center;
    margin: 0.6rem 0;
    font-size: 0.52rem !important;
    font-weight: 400;
    color: #222222;
}
.share-title-tip {
    padding: 0 0.1rem;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.1rem;
    font-size: 0.4rem !important;
    color: #fff !important;
    background: #0089ff;
    border-radius: 4px;
}
.share-person-msg {
    margin: 1.02rem 0 0.88rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.share-person-msg img {
    width: 2.96rem;
    height: 2.96rem;
    border-radius: 100%;
}

.share-footer {
    width: 100%;
    height: 4.62rem;
    padding: 0 0.4rem;
    margin-bottom: 0.4rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background: #f1f1f5;
    border-radius: 4px;
}

.footer-left {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer-left img {
    width: 2.01rem;
    height: 2.01rem;
}
.footer-left span {
    font-size: 0.4rem;

    font-weight: 400;
    color: #888888;
}
.footer-right {
    display: flex;
    justify-content: center;
    align-items: center;
}
.right-text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 0.2rem;
    font-size: 0.4rem;
    font-weight: 400;
    color: #888888;
}
.dan-right-text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 0.2rem;
    font-size: 0.4rem;
    font-weight: 400;
    color: #888888;
    p {
        font-size: 12px;
        font-weight: 400;
        color: #888888;
    }
}
.right-erweima {
    width: 3.5rem;
    height: 3.5rem;
    overflow: hidden;
    img {
        width: 4.8rem;
        height: 4.8rem;
        // margin: -1rem 0 0 -1rem;
        margin-left: -0.65rem;
        margin-top: -0.65rem;
    }
}
.line {
    height: 1px;
    width: 100%;
}
.save_posters {
    margin-top: 0.2rem;
    font-size: 0.52rem;
    color: #ff8629;
    width: 14rem;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.save_posters .poster-close {
    cursor: pointer;
    width: 1.48rem;
    height: 1.48rem;
}
.save_posters span {
    font-size: 0.52rem;
    font-weight: 400;
    color: #ffffff;
}
.poster_box {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.posters_img {
    max-width: 90%;
    max-height: 85%;
    object-fit: cover;
}

.poster-content-header {
    width: 100%;
    /* height: 7.11rem; */
    display: flex;
    justify-content: center;
    align-items: center;
    background: black;
}

.poster-content-logo {
    margin-left: 0.85rem;
    width: 0.81rem;
    height: 0.81rem;
}

.poster-content-title {
    font-size: 0.4rem;
    color: #888888;
    margin-left: 0.25rem;
}

.poster-content-learning-type {
    line-height: 0.77rem;
    text-align: center;
    width: 1.71rem;
    height: 0.77rem;
    background-color: #ccd7ff;
    border-radius: 0.38rem;
    font-size: 0.4rem;
    color: #1244f1;
    margin-right: 0.64rem;
}

.poster-content-wrap {
    /* height: 22rem; */
    padding: 0.4rem 0.4rem 0 0.4rem;
    box-sizing: border-box;
}

.flex-1 {
    flex: 1;
}
.save_loading {
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.save_loading img {
    width: 90%;
    height: 90%;
    margin: 0 auto;
    margin-top: 1rem;
}
.save_wrong {
    margin-top: 0.2rem;
    font-size: 0.52rem;
    color: #ff8629;
    width: 14rem;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.save_wrong img {
    cursor: pointer;
    width: 1.48rem;
    height: 1.48rem;
}
.save_wrong .retry_text {
    color: #6194fe;
    font-size: 0.52rem;
    cursor: pointer;
}
.save_wrong .retry_img {
    margin-left: 0.5rem;
    width: 0.55rem;
    height: 0.55rem;
}
@media screen and (min-width: 768px) {
    .show_posters {
        width: 580px;
        margin: 0 auto !important;
        overflow: hidden;
    }
    .save_loading img {
        width: 70%;
        height: 70%;
        margin: 0 auto;
        margin-top: 1rem;
    }
    // .posters_img {
    //     width: 580px !important;
    //     margin: 0 auto;
    //     height: 80%;
    //     z-index: 3;
    // }
}
</style>
